import React, { ReactNode } from 'react';

interface FormFieldProps {
    label: string;
    badge?: ReactNode;
    children: ReactNode;
    className?: string;
}

export default function FormField({ label, badge, children, className }: FormFieldProps) {
    return (
        <div className={`space-y-1 ${className || ''}`}>
            <div className="flex justify-between items-center px-1">
                <label className="text-[11px] font-bold text-txt-muted uppercase tracking-wider">{label}</label>
                {badge}
            </div>
            <div className="rounded-2xl p-4 transition-colors focus-within:border-electric-blue/50" style={{ background: 'var(--input-bg)', borderWidth: 1, borderStyle: 'solid', borderColor: 'var(--input-border)' }}>
                {children}
            </div>
        </div>
    );
}
